<div class="app-container">
  <loading-spinner [isLoading]="productDetailService.loading" [classesString]="'top-25'"></loading-spinner>
  @if (productDetailService.isCreating || productDetailService.product) {
    <page-header
      [icon]="'far-cube'"
      [title]="productDetailService.isCreating ? 'product.new' : ''"
      [appendNoTranslationTitlePart]="productDetailService.isCreating ? '' : productDetailService.product.fullName"
      [isOnProductWithAllBtns]="
        productDetailService.product?.id > 0 &&
        (!productDetailService.product.children || productDetailService.product.children?.length === 0) &&
        !productDetailService.isCreating &&
        productDetailService.product.isDeletable
      "
    >
      <ng-container class="header-button">
        <btn
          [btnType]="'submit'"
          [classes]="['btn-first', 'float-right']"
          [label]="'save'"
          [title]="'save' | translate"
          [icon]="'far-check'"
          (onEvent)="productDetailService.isCreating ? createProduct() : updateProduct()"
          [isLoading]="productDetailService.loading"
          [spinnerClassesString]="'spinner-white'"
          [dataCyAttribute]="'added-product'"
        ></btn>
        @if (!productDetailService.isCreating && productDetailService.product?.id > 0) {
          <modal-loggable-history
            [objectClass]="'Product'"
            [objectId]="productDetailService.product.id"
          ></modal-loggable-history>
        }
        @if (
          productDetailService.product?.id > 0 &&
          (!productDetailService.product.children || productDetailService.product.children?.length === 0) &&
          !productDetailService.product.isBundle
        ) {
          <modal-stock-load
            [product]="productDetailService.product"
            [depots]="productDetailService.queryDepotsOptions.data()"
            [suppliers]="productDetailService.querySuppliers.data()"
            (result)="productDetailService.refreshProduct()"
            [currencies]="productDetailService.queryCurrencies.data()"
          ></modal-stock-load>
        }
        @if (!productDetailService.isCreating) {
          <btn
            [btnType]="'submit'"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [label]="'duplicate'"
            [title]="'duplicate' | translate"
            [icon]="'fa-solid fa-clone'"
            [routerLink]="['/product']"
            [queryParams]="{ id: productDetailService.product.id }"
            [isLoading]="productDetailService.loading"
            [spinnerClassesString]="'spinner-white'"
            [dataCyAttribute]="'duplicate-product'"
            [replaceUrl]="true"
          ></btn>
        }
        @if (!productDetailService.isCreating && productDetailService.product.isDeletable) {
          <btn
            [btnType]="'button'"
            [classes]="[
              productDetailService.product.children?.length > 0 || productDetailService.product.isBundle
                ? 'd-none'
                : '',
              'btn-first-red',
              'float-right',
              'me-2'
            ]"
            [btnDisabled]="productDetailService.loading"
            [label]="'delete'"
            [icon]="'far-trash-alt'"
            [dataCyAttribute]="'delete-product'"
            [title]="'delete' | translate"
            (onEvent)="deleteProduct()"
          ></btn>
        }
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'me-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="goBack()"
        ></btn>
      </ng-container>
    </page-header>
  }

  @if (!productDetailService.isCreating && !productDetailService.loading && !!productDetailService.product) {
    <section class="content">
      <nav class="tab-container" type="pills">
        <ul role="tablist" class="nav nav-pills">
          @for (link of activeLinks; track link) {
            <li class="nav-item product-tab-heading">
              @if (link !== 'leaflets' || (link === 'leaflets' && productDetailService.hasRoleLeaflets)) {
                <a
                  (click)="activeLink = link"
                  [ngClass]="activeLink === link ? 'active' : ''"
                  class="nav-link"
                  data-cy="product-nav-link"
                  [routerLink]="link !== 'common' ? link : '/product/' + productDetailService.product.id"
                  >{{ 'product.tab.' + link | translate }}</a
                >
              }
            </li>
          }
        </ul>
      </nav>
      <router-outlet></router-outlet>
    </section>
  }

  @if (!productDetailService.loading && productDetailService.isCreating) {
    <section class="content">
      <product-form></product-form>
    </section>
  }
</div>
